/*
 * @Author: Teemo Ding
 * @Date: 2021-06-10 15:23:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-01 10:37:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/ReviewKeywords/index.tsx
 */

import React from 'react';

import { Input } from '@/src/components/Antd';
import { WrappedTagsGroup } from '@/src/components/TagGroup/TagGroup';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useDispatch } from 'react-redux';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  addReviewKeywordsTagsAdd,
  addReviewKeywordsTagsRemove,
  addReviewKeywordsTextOnchange,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getReviewKeywords,
  onCollapseOpen,
  onErrorChange,
} from '../slice';
const ReviewKeywords = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, disabled } = props;
  const { tags, text } = data;

  const _d = useDispatch();
  const tagsList = tags.map((item) => ({
    name: item,
  }));
  const handleOnChange = (value) => {
    _d(addReviewKeywordsTextOnchange({ text: value }));
  };

  const handleTagsClose = (index) => {
    _d(addReviewKeywordsTagsRemove({ index }));
  };

  const handlePressEnter = () => {
    _d(addReviewKeywordsTagsAdd({}));
  };

  return (
    <Section bottomBorder>
      <ItemWrapper
        bottomTitle={getI18n(
          'salesChannelProductContent.index.maximum5keywords',
        )}
        title={getI18n('salesChannelProductContent.index.keywords')}>
        <Input
          size='large'
          value={text}
          onChange={handleOnChange}
          onPressEnter={handlePressEnter}
          maxLength={50}
          disabled={tagsList.length === 5 || disabled}
          placeholder={getI18n(
            'salesChannelProductContent.index.pressentertoaddnewkeywords',
          )}
        />
        <WrappedTagsGroup
          closable
          tags={tagsList}
          onClose={handleTagsClose}
          tagClassName={css.tags}
        />
      </ItemWrapper>
    </Section>
  );
};

export default ErrorProcessingHOC(ReviewKeywords, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.reviewKeywords,
  getContent: getReviewKeywords,
  title: getI18nFromGeneral('general.hOCTitle.reviewKeywords'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
